import type { AppDefinition } from '../../../../types/apps';

const emDefinition: AppDefinition = {
  appId: 'phys-em',
  name: 'E/M Calculator',
  version: '1.0.0',
  description: '2021 AMA E/M level calculator using Medical Decision Making (MDM) — 99202-99215.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-em',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'ChartBar',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-em',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
  hidden: true,
};

export default emDefinition;
